module.exports = __webpack_public_path__ + "static/IMG_5408-3e86371e4e1008b4fcf09a8d32981b87.jpg";